import { render, staticRenderFns } from "./global-navi.vue?vue&type=template&id=5a5ce627&"
import script from "./global-navi.vue?vue&type=script&lang=js&"
export * from "./global-navi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports